 const activeColor = {
  color: '#2e2c7e'
};

export default activeColor;